<template>
  <div id="custom-row-form-container">
    <div class="form-group" v-for="(form, index) in forms.filter(form => form.display ? form.display(result) : true)" :key="index" :style="form.width ? { flexBasis: form.width } : { flex: form.flex || 1 }">
      <div>
        <form v-if="display" :data-vv-scope="scope">
          <div v-if="form.type || form.title">
            <div class="label row-block" v-if="form.title">
              <span class="title">{{ form.title }}</span>
              <div :style="{ width: '2px' }"></div>
              <span class="required" v-if="form.validate && form.validate.includes('required')">{{ (form.requiredMsg || (() => '*'))(form) }}</span>
              <span class="description">{{ form.description }}</span>
              <span class="invisible">{{ form.invisible }}</span>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div v-if="form.type && result[form.value] !== undefined" class="options" :class="[form.type]" :style="{ flex: 1 }">
              <template v-if="form.type === 'input'">
                <div class="input-group">
                  <input type="text" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" @keydown.enter.prevent />
                </div>
              </template>
              <template v-else-if="form.type === 'password'">
                <div class="input-group">
                  <input type="password" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" @keydown.enter.prevent />
                </div>
              </template>
              <template v-else-if="form.type === 'textarea'">
                <div class="input-group">
                  <textarea :id="form.value" :name="form.value" :tabindex="form.tabindex" :rows="form.row" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'select'">
                <div class="input-group">
                  <select :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="disabled || (form.disabled || (() => false))(result)" :style="form.style ? form.style(result[form.value]) : result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" v-validate="form.validate">
                    <option v-if="form.placeholder" value="" disabled>{{ form.placeholder(form) }}</option>
                    <option v-for="(option, index) in form.options" :key="index" :value="option.value || ''" :disabled="option.disabled" :style="option.style || {}">{{ option.title }}</option>
                  </select>
                </div>
              </template>
              <template v-if="form.type === 'datalist'">
                <div class="input-group">
                  <input type="text" autocomplete="off" :id="form.value" :name="form.value" :list="form.value + '-list'" :tabindex="form.tabindex" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => datalistOnChange(form, result)" v-validate="form.validate" @keydown.enter.prevent />
                  <template v-if="form.customList">
                    <div v-if="form.lists && form.lists.length" class="datalist">
                      <div class="option" v-for="(option, index) in form.lists" :key="index" @click="e => result[form.value] = option">{{ option }}</div>
                    </div>
                  </template>
                  <template v-else>
                    <datalist v-if="form.lists && form.lists.length" :id="form.value + '-list'">
                      <option v-for="(option, index) in form.lists" :key="index">{{ option }}</option>
                    </datalist>
                  </template>
                </div>
              </template>
              <template v-else-if="form.type === 'boolean'">
                <div class="input-group">
                  <label :for="form.value" :class="{ diabled: (form.disabled || (() => false))(result) }">
                    <input type="checkbox" :id="form.value" :name="form.value" :tabindex="form.tabindex" :disabled="disabled || (form.disabled || (() => false))(result)" v-model="result[form.value]" v-validate="form.validate" />
                  </label>
                </div>
              </template>
              <template v-else-if="form.type === 'single'">
                <div class="input-group" v-for="(option, index) in form.options" :key="index">
                  <label :for="form.value + '_' + option.value" :class="{ diabled: (form.disabled || (() => false))(result) }">
                    <input type="radio" :id="form.value + '_' + option.value" :name="form.value" :value="option.value" :disabled="disabled || (form.disabled || (() => false))(result)" v-model="result[form.value]" v-validate="form.validate" />
                    <span>{{ option.title }}</span>
                  </label>
                </div>
              </template>
              <template v-else-if="form.type === 'multiple'">
                <div class="input-group" v-for="(option, index) in form.options" :key="index">
                  <label :for="form.value + '_' + option.value" :class="{ diabled: (form.disabled || (() => false))(result) || form.range && ((form.range[0] === (result[form.value] || []).length && result[form.value].includes(option.value)) || (form.range[1] === (result[form.value] || []).length && !result[form.value].includes(option.value))) }">
                    <input type="checkbox" :id="form.value + '_' + option.value" :name="form.value" :value="option.value" :disabled="disabled || (form.disabled || (() => false))(result) || (form.range && ((form.range[0] === (result[form.value] || []).length && result[form.value].includes(option.value)) || (form.range[1] === (result[form.value] || []).length && !result[form.value].includes(option.value))))" v-model="result[form.value]" v-validate="form.validate" />
                    <span>{{ option.title }}</span>
                  </label>
                </div>
              </template>
              <template v-else-if="form.type === 'number'">
                <div class="input-group">
                  <input type="number" :id="form.value" :name="form.value" :tabindex="form.tabindex" :step="form.step" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : null" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'date'">
                <div class="input-group">
                  <input type="date" :id="form.value" :name="form.value" :tabindex="form.tabindex" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : '9999-12-31'" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'time'">
                <div class="input-group">
                  <input type="time" :id="form.value" :name="form.value" :tabindex="form.tabindex" :step="form.step" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : null" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'datetime'">
                <div class="input-group">
                  <input type="datetime-local" :id="form.value" :name="form.value" :tabindex="form.tabindex" :step="form.step" :min="form.range ? form.range[0] : null" :max="form.range ? form.range[1] : null" :disabled="disabled || (form.disabled || (() => false))(result)" :placeholder="(form.placeholder || (() => ''))(form)" :style="result[form.value] ? {} : { color: '#777777' }" v-model="result[form.value]" @change="e => (form.onChange || (() => {}))(result[form.value])" v-validate="form.validate" />
                </div>
              </template>
              <template v-else-if="form.type === 'file'">
                <div class="input-group">
                  <input type="file" v-show="false" :id="form.value" :name="form.value" :multiple="form.multiple" :accept="form.accept" :disabled="disabled || (form.disabled || (() => false))(result)" @change="e => e.target.files.length ? Array.from(e.target.files) : []" v-validate="form.validate" />
                  <button :tabindex="form.tabindex">
                    <span>{{ form.text || 'select' }}</span>
                    <label :for="form.value" :class="{ diabled: (form.disabled || (() => false))(result) }"></label>
                  </button>
                  <template v-if="!$scopedSlots[form.value]">
                    <div v-for="(file, index) in result[form.value] || []" :key="index">
                      <span>{{ file.name }}</span>
                    </div>
                  </template>
                </div>
              </template>
              <template v-else-if="form.type === 'text'">
                <div class="input-group">
                  <span :style="(form.style || (() => ({})))(result[form.value])">{{ (form.displayText || (x => x))(result[form.value], form) }}</span>
                </div>
              </template>
              <div :class="(alerts[form.value] || { type: 'error' }).type">
                <span v-if="alerts[form.value]">{{ alerts[form.value].msg }}</span>
                <span v-else-if="errors.has(scope + '.' + form.value) || form.error">{{ (form.alert || (() => null))(form, errors.first(scope + '.' + form.value)) || (errors.first(scope + '.' + form.value) || form.error).replace(form.value, form.errorTitle || form.title) }}</span>
              </div>
            </div>
          </div>
          <div class="custom" :class="{ 'main-custom': !form.type && !form.title }">
            <slot v-if="$scopedSlots[form.value]" :name="form.value" :data="result" :result="result[form.value]" :output="output[form.value]" :form="form"></slot>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    forms: {
      type: Array,
      required: true
    },
    init: {
      type: Object,
      default: () => ({})
    },
    alerts: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    scope: {
      type: String,
      default: () => 'form'
    }
  },
  data () {
    return {
      result: {},
      output: {},
      display: true
    }
  },
  watch: {
    'forms' () {
    },
    'init' () {
      this.initialResults()
    },
    'result': {
      handler: async function () {
        this.output = await this.afterTreatment(this.result)
        this.$emit('change', this.output, this.$validator, this.errors)
      },
      deep: true
    }
  },
  created () {
    this.initialResults()
  },
  methods: {
    async initialResults () {
      let input = await this.preTreatment(this.init)
      let initials = {
        input: '',
        password: '',
        textarea: '',
        boolean: false,
        select: '',
        datalist: '',
        single: '',
        multiple: [],
        number: '',
        date: '',
        time: '',
        datetime: '',
        file: [],
        text: ''
      }
      this.result = this.forms.reduce((s, c) => ({ ...s, ...c.value ? { [c.value]: input[c.value] !== null && input[c.value] !== undefined ? input[c.value] : initials[c.type] } : {} }), {})
    },
    async preTreatment (init) {
      let input = {}
      for (let form of this.forms) {
        form.value && (input[form.value] = await (form.inputFormat || (async x => x))(init[form.value], form))
      }
      return input
    },
    async afterTreatment (result) {
      let output = {}
      for (let form of this.forms) {
        form.value && (output[form.value] = await (form.outputFormat || (async x => x))(result[form.value], form))
      }
      return output
    },
    datalistOnChange (form, result) {
      setTimeout(() => (form.onChange || (() => {}))(result[form.value]), 50)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#custom-row-form-container
  // border: 1px solid #777777
  // padding: 10px
  width: 100%
  display: flex
  flex-direction: row
  flex-wrap: wrap
  align-items: stretch
  justify-content: space-between
  .form-group
    width: 0
    position: relative
    padding-bottom: 25px
    &.disabled
      opacity: 0.5
    &:not(:last-child)
      margin-right: 20px
    .label
      margin-bottom: 5px
      padding: 0 5px
      & > span
        white-space: nowrap
      .title
        font-weight: bold
      .required
        color: red
      .description
        font-size: 12px
      .invisible
        font-size: 12px
        color: transparent
    .options
      .input-group
        padding: 0
      input, textarea, select
        &:disabled
          cursor: not-allowed !important
      label
        &.diabled
          cursor: not-allowed !important
      &.input
        & > div
          input[type="text"]
            // width: 100%
            // padding: 1px 2px
            // box-sizing: border-box
      &.password
        & > div
          input[type="password"]
            // width: 100%
            // padding: 1px 2px
            // box-sizing: border-box
      &.textarea
        & > div
          textarea
            // width: 100%
            // padding: 1px 2px
            // box-sizing: border-box
            // resize: none
      &.select
        & > div
          select
          //  width: 100%
          //  padding: 1px 2px
          //  option
          //   color: black
          //   &:disabled
          //     color: #777777
      &.datalist
        & > div
          input[type="text"]
            // width: 100%
            // padding: 1px 2px
            // box-sizing: border-box
            &:focus
              & + .datalist
                display: inline
          .datalist
            display: none
            max-height: 300px
            min-width: 100%
            overflow: auto
            // left: 0
            top: 64px
            background: white
            box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.16)
            border-radius: 3px
            position: absolute
            z-index: 5
            user-select: none
            &:hover
              display: inline
            .option
              padding: 10px
              white-space: nowrap
              &:hover
                background: #999999
      &.boolean
        & > div
          display: flex
          label
            display: flex
            width: 100%
            padding: 3px
            &:hover
              background: #cccccc
              cursor: pointer
            input[type="checkbox"]
              margin-right: 5px
              padding: 1px 2px
      &.single
        & > div
          display: flex
          label
            display: flex
            align-items: center
            width: 100%
            padding: 3px
            &:hover
              background: #cccccc
              cursor: pointer
            input[type="radio"]
              margin-right: 5px
              margin-top: 1px
              padding: 1px 2px
            span
              word-break: break-all
      &.multiple
        & > div
          display: flex
          label
            display: flex
            align-items: center
            width: 100%
            padding: 3px
            cursor: pointer
            &.disabled
              cursor: not-allowed
              span
                color: #999999
            &:hover
              background: #cccccc
            input[type="checkbox"]
              margin-right: 5px
              margin-top: 1px
              padding: 1px 2px
            span
              word-break: break-all
      &.number
        & > div
          display: flex
          input[type="number"]
            // width: 100%
            // padding: 1px 2px
      &.date
        & > div
          display: flex
          input[type="date"]
            // width: 100%
            // padding: 1px 2px
      &.time
        & > div
          display: flex
          input[type="time"]
            // width: 100%
            // padding: 1px 2px
      &.datetime
        & > div
          display: flex
          input[type="datetime-local"]
            // width: 100%
            // padding: 1px 2px
      &.file
        & > div
          button
            position: relative
            label
              position: absolute
              width: 100%
              height: 100%
              top: 0
              left: 0
              cursor: pointer
      &.text
        & > div
          margin-left: 10px
    .error
      font-size: 12px
      position: absolute
      bottom: 8px
      left: 5px
      span
        color: red
    .success
      font-size: 12px
      position: absolute
      bottom: 8px
      left: 5px
      span
        color: green
    .custom
      &.main-custom
        margin-bottom: 2px
      & > div > .label + div
        padding: 0
        min-height: 34px
</style>



// WEBPACK FOOTER //
// src/components/tool/customRowForm.vue